export default __webpack_public_path__ + "static/media/image-cover.21eb7096.png";